import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { PromptStatsResponse } from "./dtos";

const PROMPT_SERVICE = `${Constants.API_URL}/bedrock/prompts`;

export class PromptServices {
  @scCatchServiceException()
  static async getPromptStats(promptId: string | number): Promise<PromptStatsResponse> {
    const { data } = await axios.get<PromptStatsResponse>(`${PROMPT_SERVICE}/${promptId}/stats`);
    return data;
  }
}
